// Маппинг ошибок с английского на русский
const errorTranslations = {
  // Общие ошибки
  'Invalid credentials': 'Неверный логин или пароль',
  'Invalid login or password': 'Неверный логин или пароль',
  'User not found': 'Пользователь не найден',
  'Not found': 'Не найдено',
  'Unauthorized': 'Не авторизован',
  'Forbidden': 'Доступ запрещен',
  'Internal server error': 'Внутренняя ошибка сервера',
  'Network error': 'Ошибка сети',
  'Request failed': 'Запрос не выполнен',
  'Page.goto: Timeout 15000ms exceeded.': 'Сервер не смог открыть страницу: превышено время ожидания',
  'Page.goto: Timeout 30000ms exceeded.': 'Сервер не смог открыть страницу: превышено время ожидания',
  'net::ERR_NAME_NOT_RESOLVED': 'Сервер не смог открыть страницу: домен недоступен',
  'net::ERR_CONNECTION_REFUSED': 'Сервер не смог открыть страницу: соединение отклонено',
  'Navigation failed because browser has disconnected!': 'Сервер не смог открыть страницу: браузер недоступен',
  
  // Ошибки аутентификации
  'Token expired': 'Токен истек',
  'Invalid token': 'Неверный токен',
  'Token not provided': 'Токен не предоставлен',
  'Authentication failed': 'Ошибка аутентификации',
  'Login already taken': 'Логин уже занят',
  'Email already registered': 'Email уже зарегистрирован',
  'Phone already registered': 'Телефон уже зарегистрирован',
  'Nickname already taken': 'Никнейм уже занят',
  'Password too weak': 'Пароль слишком слабый',
  'Current password is incorrect': 'Текущий пароль неверен',
  
  // Ошибки валидации
  'Validation error': 'Ошибка валидации',
  'Missing required fields': 'Отсутствуют обязательные поля',
  'Invalid email format': 'Неверный формат email',
  'Invalid phone format': 'Неверный формат телефона',
  'Invalid UUID format': 'Неверный формат UUID',
  'User ID is required': 'Требуется ID пользователя',
  
  // Ошибки файлов
  'Avatar file is required': 'Требуется файл аватара',
  'Invalid file type': 'Неверный тип файла',
  'File too large': 'Файл слишком большой',
  'Avatar file size too large': 'Размер файла аватара слишком большой',
  'Invalid avatar format': 'Неверный формат аватара',
  
  // Ошибки задач
  'Task not found': 'Задача не найдена',
  'Task creation failed': 'Ошибка при создании задачи',
  'Task update failed': 'Ошибка при обновлении задачи',
  'Task is still processing': 'Задача ещё обрабатывается — дождитесь завершения',
  'MHTML file is required': 'Необходимо выбрать MHTML-файл',
  'TASK_PROCESSING': 'Задача ещё обрабатывается',
  
  // Ошибки админки
  'Cannot delete self': 'Нельзя удалить свой собственный аккаунт',
  'User deleted successfully': 'Пользователь успешно удален',
  'Insufficient balance': 'Недостаточно запросов',
  'Insufficient requests balance. Please purchase a package.': 'Недостаточно запросов. Пожалуйста, приобретите пакет.',
  'Invalid amount': 'Неверная сумма',
  
  // Коды ошибок
  'INSUFFICIENT_FUNDS': 'Недостаточно запросов',
  'MISSING_USER_ID': 'Требуется ID пользователя',
  'INVALID_UUID_FORMAT': 'Неверный формат UUID',
  'USER_NOT_FOUND': 'Пользователь не найден',
  'CANNOT_DELETE_SELF': 'Нельзя удалить свой собственный аккаунт',
  'LOGIN_EXISTS': 'Логин уже занят',
  'EMAIL_EXISTS': 'Email уже зарегистрирован',
  'PHONE_EXISTS': 'Телефон уже зарегистрирован',
  'NICKNAME_EXISTS': 'Никнейм уже занят',
  'PASSWORD_TOO_WEAK': 'Пароль слишком слабый',
  'INVALID_CURRENT_PASSWORD': 'Текущий пароль неверен',
  'MISSING_AVATAR': 'Требуется файл аватара',
  'INVALID_AVATAR_FORMAT': 'Неверный формат аватара',
  'AVATAR_TOO_LARGE': 'Размер файла аватара слишком большой',
  'MISSING_AVATAR_FILE': 'Требуется файл аватара',
  'INVALID_FILE_TYPE': 'Неверный тип файла',
  'VALIDATION_ERROR': 'Ошибка валидации',
  'INVALID_PHONE_FORMAT': 'Неверный формат телефона',
  'Validation failed': 'Проверьте заполнение формы',
  'Проверьте заполнение формы': 'Проверьте заполнение формы',
  'INVOICE_CREATE_ERROR': 'Не удалось сформировать счёт',
  'MISSING_REQUIRED_FIELDS': 'Отсутствуют обязательные поля',
  'INTERNAL_ERROR': 'Внутренняя ошибка сервера',
  'TARIFF_ALREADY_USED': 'Вы уже использовали этот акционный тариф',
  'TARIFF_FIRST_PURCHASE_ONLY': 'Этот тариф доступен только для первой покупки',
  'TARIFF_NOT_ELIGIBLE': 'Этот тариф недоступен для вашего аккаунта',
  'TARIFF_INACTIVE': 'Тариф недоступен',
  'MISSING_ELIGIBLE_USERS': 'Для персонального тарифа нужно выбрать пользователей',
  'DUPLICATE_LANDING_TYPE': 'Этот type уже используется другим тарифом',
  'INVALID_LANDING_TYPE': 'Type должен быть положительным числом',
  'This landing type is already used by another tariff': 'Этот type уже используется другим тарифом',
  'landing_type must be a positive integer': 'Type должен быть положительным числом',
  'You have already purchased this promotional tariff': 'Вы уже использовали этот акционный тариф',
  'This tariff is available only for first purchase': 'Этот тариф доступен только для первой покупки',
  'This tariff is not available for your account': 'Этот тариф недоступен для вашего аккаунта',
  'Personal tariff requires at least one eligible user': 'Для персонального тарифа нужно выбрать пользователей',
};

const SERVER_FIELD_TO_FORM = {
  login: 'login',
  phone: 'phone',
  email: 'email',
  first_name: 'firstName',
  last_name: 'lastName',
  nickname: 'nickname',
  password_hash: 'password',
};

/**
 * Переводит ошибку на русский язык
 * @param {string} error - Текст ошибки или код ошибки
 * @param {string} defaultMessage - Сообщение по умолчанию, если перевод не найден
 * @returns {string} - Переведенное сообщение
 */
export const translateError = (error, defaultMessage = 'Произошла ошибка') => {
  if (!error) return defaultMessage;
  
  // Если это строка, пытаемся найти перевод
  const errorStr = String(error).trim();
  const errorLower = errorStr.toLowerCase();

  // Частичные совпадения для типовых ошибок браузерного навигатора
  if (
    errorLower.includes('page.goto') ||
    errorLower.includes('timeout 15000ms exceeded') ||
    errorLower.includes('timeout 30000ms exceeded')
  ) {
    return 'Сервер не смог открыть страницу: превышено время ожидания. Проверьте доступность или скорость ответа сайта.';
  }
  if (errorLower.includes('net::err_name_not_resolved')) {
    return 'Сервер не смог открыть страницу: домен не найден.';
  }
  if (errorLower.includes('net::err_connection_refused')) {
    return 'Сервер не смог открыть страницу: соединение отклонено.';
  }
  if (errorLower.includes('navigation failed') || errorLower.includes('browser has disconnected')) {
    return 'Сервер не смог открыть страницу: проблема с браузером. Попробуйте позже.';
  }
  
  // Проверяем точное совпадение
  if (errorTranslations[errorStr]) {
    return errorTranslations[errorStr];
  }
  
  // Проверяем без учета регистра
  for (const [key, value] of Object.entries(errorTranslations)) {
    if (key.toLowerCase() === errorLower) {
      return value;
    }
  }
  
  // Если это объект с полем error или message
  if (typeof error === 'object') {
    if (error.error && errorTranslations[error.error]) {
      return errorTranslations[error.error];
    }
    if (error.message && errorTranslations[error.message]) {
      return errorTranslations[error.message];
    }
    if (error.code && errorTranslations[error.code]) {
      return errorTranslations[error.code];
    }
  }
  
  // Если перевод не найден, возвращаем оригинал или сообщение по умолчанию
  return errorStr || defaultMessage;
};

/**
 * Разбирает ответ API с ошибками валидации по полям.
 * @param {Error} err - Объект ошибки от axios
 * @param {string} defaultMessage - Сообщение по умолчанию
 * @returns {{ message: string, fieldErrors: Object<string, string> }}
 */
export const parseApiValidationError = (err, defaultMessage = 'Произошла ошибка') => {
  const data = err?.response?.data;
  const fieldErrors = {};

  if (Array.isArray(data?.details)) {
    data.details.forEach((item) => {
      if (!item.field || !item.message) return;
      const formField = SERVER_FIELD_TO_FORM[item.field] || item.field;
      fieldErrors[formField] = translateError(item.message, item.message);
    });
  }

  const detailMessages = Object.values(fieldErrors);
  if (detailMessages.length) {
    return {
      message: detailMessages.join('. '),
      fieldErrors,
    };
  }

  if (data?.error) {
    return {
      message: translateError(data.error, defaultMessage),
      fieldErrors: {},
    };
  }

  if (data?.message) {
    return {
      message: translateError(data.message, defaultMessage),
      fieldErrors: {},
    };
  }

  if (data?.code) {
    return {
      message: translateError(data.code, defaultMessage),
      fieldErrors: {},
    };
  }

  if (err?.message) {
    return {
      message: translateError(err.message, defaultMessage),
      fieldErrors: {},
    };
  }

  return { message: defaultMessage, fieldErrors: {} };
};

/**
 * Извлекает и переводит ошибку из объекта ответа axios
 * @param {Error} err - Объект ошибки от axios
 * @param {string} defaultMessage - Сообщение по умолчанию
 * @returns {string} - Переведенное сообщение
 */
export const getTranslatedError = (err, defaultMessage = 'Произошла ошибка') => {
  if (!err) return defaultMessage;

  const parsed = parseApiValidationError(err, defaultMessage);
  if (Object.keys(parsed.fieldErrors).length > 0) {
    return parsed.message;
  }

  // Пытаемся извлечь ошибку из response
  if (err.response?.data) {
    const data = err.response.data;

    // Проверяем разные варианты структуры ответа
    if (data.error) {
      return translateError(data.error, defaultMessage);
    }
    if (data.message) {
      return translateError(data.message, defaultMessage);
    }
    if (data.code) {
      return translateError(data.code, defaultMessage);
    }
    if (typeof data === 'string') {
      return translateError(data, defaultMessage);
    }
  }

  // Если есть message в самой ошибке
  if (err.message) {
    return translateError(err.message, defaultMessage);
  }

  return defaultMessage;
};

export default translateError;

